/* raw layout hash: _user-role-management-layout:4413c7cc62d99c98b21d3a4611fcbc8a54073282d56db12d3d155ed95665b06b */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _user-role-management-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function UserRoleManagementLayout() {
  return <AppShell />;
}
